export default function Footer() {
  return (
    <footer className="bg-earth-700 text-white">
      <div className="max-w-7xl mx-auto py-8 px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-lg font-semibold mb-4">Kapcheboin Clan</h3>
            <p className="text-earth-100">
              Preserving our rich cultural heritage and connecting our community 
              across generations through digital storytelling and artifact preservation.
            </p>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li><a href="/artifacts" className="text-earth-100 hover:text-white transition-colors">Artifacts</a></li>
              <li><a href="/blog" className="text-earth-100 hover:text-white transition-colors">Community Blog</a></li>
              <li><a href="/profile" className="text-earth-100 hover:text-white transition-colors">Member Portal</a></li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold mb-4">Connect With Us</h3>
            <p className="text-earth-100 mb-2">
              Join our community and help preserve our heritage for future generations.
            </p>
            <p className="text-earth-100 text-sm">
              Contact: info@kapcheboin.com
            </p>
          </div>
        </div>
        
        <div className="border-t border-earth-500 mt-8 pt-8 text-center">
          <p className="text-earth-100">
            © 2024 Kapcheboin Clan. All rights reserved. Built with pride for our community.
          </p>
        </div>
      </div>
    </footer>
  )
}